import { Box, Text } from "grommet";
import Link from "next/link";
import styled from "styled-components";
import capitalFirst from "@helpers/capitalFirst";

const Container = styled.a`
  text-decoration: none;
  &:hover > * {
    background: #999;
  }
`;

export function Topic({ value, size, ...rest }) {
  return (
    <Link href={`/blog/topics/${value}`} passHref legacyBehavior>
      <Container data-ga={`articleTopic::click::${value}`}>
        <Box
          round="small"
          background="dark-1"
          pad={
            size === "small"
              ? { horizontal: "xsmall", vertical: "xxsmall" }
              : { horizontal: "small", vertical: "xsmall" }
          }
          {...rest}
        >
          <Text weight="normal" color="status-disabled">
            {capitalFirst(value)}
          </Text>
        </Box>
      </Container>
    </Link>
  );
}

export default function Topics({ categories }) {
  return (
    <Box direction="row">
      {categories.map((category) => (
        <Topic key={category} value={category} margin="small" />
      ))}
    </Box>
  );
}
